import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36cf592c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stunt__header" }
const _hoisted_2 = { class: "stunt__name" }
const _hoisted_3 = { class: "stunt__skill" }
const _hoisted_4 = { class: "stunt__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddNewAndEditStunt = _resolveComponent("AddNewAndEditStunt")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", {
      class: "stunt",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true))
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.stunt.name), 1),
        _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t(`skill__${_ctx.stunt.skill}`)), 1)
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.stunt.description), 1)
    ]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('edit-stunt')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddNewAndEditStunt, {
          stunt: _ctx.stunt,
          mode: "edit",
          onRemove: _ctx.remove,
          onUpdate: _ctx.update,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = false))
        }, null, 8, ["stunt", "onRemove", "onUpdate"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}